<template>
  <material-card>
    <v-layout px-3 slot="header">
      <v-flex mt-2 pl-3 align-center justify-center>
        <div class="headline">Obiekty</div>

        <p>Lista obiektów partnera</p>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex text-xs-right pb-0>
        <check-permission permissions="PLACE.ADD" entityType="partner" :entityId="partnerId">
          <v-btn large color="error" @click="showAddModal">DODAJ OBIEKT</v-btn>
        </check-permission>
      </v-flex>
    </v-layout>

    <material-table
      editPerm="PLACE.UPDATE"
      deletePerm="PLACE.DELETE"
      entityType="place"
      :headers="table.headers"
      :items="list"
      :total-count="count"
      :actions="true"
      :delete-action="list.length > 1"
      @pagination="reloadPlaces"
      @add="showAddModal"
      @edit="showEditModal"
      @delete="deleteValidation"
    ></material-table>

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy na pewno chcesz usunąć Obiekt? Usunięcie Obiektu spowoduje usunięcie przypisanych do niego usług."
      :show="!!idToDelete"
      :id="idToDelete"
      @close="hideDeleteDialog"
      @confirm="remove"
    ></material-dialog>

    <add
      :show="showModal"
      :id="idToEdit"
      @close="hideModal"
      @save="savePlace"
      @update="updatePlace"
    ></add>
  </material-card>
</template>

<script>
import { mapState } from 'vuex';
import { SessionStorage, address } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import MaterialDialog from '@/components/material/Dialog';
import Add from './modals/AddPlace.modal';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DEFAULT_LIST_COUNT } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania listy obiektów.',
  getError: 'Wystąpił błąd podczas pobierania danych obiektów.',
  added: 'Dodano obiekt.',
  addError: 'Nie udało się dodać obiektu.',
  updated: 'Zaktualizowano dane obiektu.',
  updateError: 'Nie udało się zaktualizować danych obiektu.',
  deleted: 'Usunięto obiekt.',
  deleteError: 'Nie udało się usunąć obiektu.'
};

export default {
  components: {
    MaterialCard,
    Add,
    MaterialTable,
    MaterialDialog
  },
  mixins: [
    listMixin('partners/places', messages, {}, (to, from, next) => {
      Promise.all([
        store.dispatch('partners/places/list', { partnerId: parseInt(to.params.id), count: DEFAULT_LIST_COUNT }),
        store.dispatch('settings/settingFindPublic', 'PUBLIC_DEFAULT_CENTER'),
        store.dispatch('settings/settingFindPublic', 'PUBLIC_DEFAULT_MAP_LEVEL')
      ])
        .then(() => next())
        .catch(err =>
          store.dispatch('notifyError', {
            title: messages.listError
          })
        );
    })
  ],

  data() {
    return {
      table: {
        headers: [
          { value: 'name', text: 'Nazwa', sortable: true },
          { value: 'displayAdress', text: 'Adres', sortable: false }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      partnerId: state => state.partners.id,
      list: state =>
        state.partners.places.list.map(place => {
          place.displayAdress = address(place);
          return place;
        }),
      count: state => state.partners.places.count
    })
  },
  methods: {
    // @vuese
    // Zapisuje obiekt
    // @arg `place` - dane Obiektu
    savePlace(place) {
      try {
        this.$store
          .dispatch('partners/places/add', { place: this.deepClone(place), partnerId: this.partnerId })
          .then(() => {
            this.notifySuccess('Dodano obiekt.');
            this.hideModal();
          });
      } catch (error) {
        this.notifyError('Nie udało się dodać obiektu.');
      }
    },
    // @vuese
    // Aktualizuje obiekt
    // @arg `data` - dane Obiektu
    updatePlace(data) {
      const id = data.id;
      data.id = undefined;
      try {
        this.$store.dispatch('partners/places/update', { id, place: this.deepClone(data) }).then(() => {
          this.notifySuccess('Zaktualizowano dane obiektu.');
          this.hideModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się zaktualizować danych obiektu.');
      }
    },
    // @vuese
    // Dodaje partnerId do paginacji
    // @arg `pagination` - Paginacja z materialTable
    reloadPlaces(pagination) {
      this.reloadList({ ...pagination, partnerId: this.partnerId });
    },
    // Sprawdza czy można usunąc obiekt
    // @arg `id` - id obiektu
    deleteValidation(id) {
      if (this.count > 1) {
        parseInt(sessionStorage.getItem(SessionStorage.PLACE_ID)) !== id
          ? this.showDeleteDialog(id)
          : this.notifyError('Nie można usunąć obiektu, który jest wybrany');
      } else {
        this.notifyError('Partner musi posiadać chociaż jeden obiekt');
      }
    }
  }
};
</script>
